import { createActions, createState, createReducer } from 'reduxsauce-crud'

const d = { deep: true }

export const IncidentRedux = createActions(
  {
    IncidentRequest: ['start_date', 'end_date'],
    IncidentSuccess: ['data', 'fileName'],
    IncidentError: ['error'],
    CentersIncidentRequest: ['start_date', 'end_date', 'centerId'],
    CentersIncidentSuccess: ['data', 'fileName'],
    CentersIncidentError: ['error'],
  },
  {
    prefix: 'INCIDENT_',
    defaultActions: {
      get: true,
    },
  },
)

const { Types, Creators } = IncidentRedux
export const IncidentTypes = Types
export default Creators

export const INITIAL_STATE = createState({
  sending: {
    fetching: false,
    error: null,
  },
}, {
  get: true,
})

/* ------------- Reducers ------------- */

const IncidentRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const IncidentSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const IncidentError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)

const CentersIncidentRequest = state => state.merge({ sending: { fetching: true, error: null } }, d)

const CentersIncidentSuccess = (state, { data, fileName }) => state.merge({
  sending: {
    fetching: false,
    error: null,
  },
  data: { file: data, fileName }
}, d)
const CentersIncidentError = (state, { error }) =>
  state.merge({ sending: { fetching: false, error } }, d)


export const reducer = createReducer(
  INITIAL_STATE, {
    [Types.IncidentRequest]: IncidentRequest,
    [Types.IncidentSuccess]: IncidentSuccess,
    [Types.IncidentError]: IncidentError,
    [Types.CentersIncidentRequest]: CentersIncidentRequest,
    [Types.CentersIncidentSuccess]: CentersIncidentSuccess,
    [Types.CentersIncidentError]: CentersIncidentError,
  },
  {
    defaultActions: {
      get: true,
    },
    Types,
  },
)



// WEBPACK FOOTER //
// ./src/Data/Redux/IncidentRedux.js